import { render, staticRenderFns } from "./ChuKuDan.vue?vue&type=template&id=2116c1c3&scoped=true&"
import script from "./ChuKuDan.vue?vue&type=script&lang=js&"
export * from "./ChuKuDan.vue?vue&type=script&lang=js&"
import style0 from "./ChuKuDan.vue?vue&type=style&index=0&id=2116c1c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116c1c3",
  null
  
)

export default component.exports